import { Outlet } from "react-router-dom";
import { SidebarDashboard } from "../components/menu/SidebarDashboard";

export default function Dashboard() {
  return (
    <div className="flex h-full min-h-screen">
      <div style={{ width: "220px" }} className="flex-none">
        <SidebarDashboard />
      </div>
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
